class Utils {
    constructor () {
        this._name = this.constructor.name
    }

    // https://gist.github.com/alirezas/c4f9f43e9fe1abba9a4824dd6fc60a55
    fadeOut (el) {
        el.style.opacity = 1

        function fade () {
            if ((el.style.opacity -= 0.1) < 0) {
                el.style.display = 'none'
            } else {
                requestAnimationFrame(fade)
            }
        }
        fade()
    }

    fadeIn (el, display) {
        el.style.opacity = 0
        el.style.display = display || 'block'

        function fade () {
            var val = parseFloat(el.style.opacity)
            if (!((val += 0.2) > 1)) {
                el.style.opacity = val
                requestAnimationFrame(fade)
            }
        }
        fade()
    }

    getPage (url, cb) {
        var xhr = new XMLHttpRequest()
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
                cb(xhr.status, xhr.responseXML)
            } else {
                cb(xhr.status, xhr.responseXML)
            }
        }

        xhr.open('GET', url)
        xhr.responseType = 'document'
        xhr.send()
    }

    getClosestParent (elem, selector) {
        for (; elem && elem !== document; elem = elem.parentNode) {
            if (elem.matches(selector)) return elem
        }
        return null
    }

    insertAfter (newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling)
    }

    updateInputs (allInputs, target, value) {
        if (allInputs.length > 0) {
            allInputs.forEach(function (input) {
                input.value = value
            })
        } else {
            target.value = value
        }
    }

    initNumberInputs () {
        let _this = this
        let numberInputs = document.querySelectorAll('.number-input')
        // For product page, update connected multiple
        let allInputs = document.querySelectorAll('.sticky-number-input')

        numberInputs.forEach(function (el) {
            let minus = el.querySelector('.number-input-minus')
            let plus = el.querySelector('.number-input-plus')
            let target = el.querySelector('.number-input-target')
            if (target && minus && plus) {
                minus.addEventListener('click', function () {
                    if (parseInt(target.value) > 1) {
                        _this.updateInputs(allInputs, target, parseInt(target.value) - 1)
                    }
                })
                plus.addEventListener('click', function () {
                    _this.updateInputs(allInputs, target, parseInt(target.value) + 1)
                })
            }
        })
    }

    initAccordion () {
        // https://www.w3schools.com/howto/howto_js_accordion.asp
        var acc = document.querySelectorAll('.accordion')

        for (var i = 0; i < acc.length; i++) {
            acc[i].addEventListener('click', function () {
                // If not active and should disable all other accordion options
                if (!this.classList.contains('active') && this.getAttribute('data-solo') === 'true') {
                    acc.forEach(function (el) {
                        if (el !== this) {
                            var allPanel = el.nextElementSibling
                            allPanel.style.maxHeight = null
                            el.classList.remove('active')
                        }
                    })
                }

                this.classList.toggle('active')

                var panel = this.nextElementSibling
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null
                } else {
                    panel.style.maxHeight = panel.scrollHeight + 'px'
                }
            })
        }
    }

    anchorLink () {
        var anchorLinks = document.querySelectorAll('.anchor-link')

        anchorLinks.forEach(function (e) {
            e.addEventListener('click', function () {
                var el = e.getAttribute('data-link')
                var top = document.getElementById(el).offsetTop
                window.scrollTo(500, top - 120)
            })
        })
    }

    initOverlay () {
        let _this = this
        let overlays = document.querySelectorAll('.overlay-trigger')

        overlays.forEach(function (el) {
            el.addEventListener('click', function () {
                _this.toggleOverlay(el)
            })
        })

        document.addEventListener('click', function (e) {
            if (e.target.classList.contains('overlay-close')) {
                _this.toggleOverlay(e.target)
            }
        })
    }

    toggleOverlay (el) {
        let overlayId = el.getAttribute('data-overlay-target')
        let overlayTarget = document.querySelector(overlayId)
        let body = document.querySelector('body')
        let html = document.querySelector('html')

        if (overlayTarget) {
            console.log(overlayTarget)
            console.log(overlayTarget.classList.contains('standard-overlay--hide'))
            if (overlayTarget.classList.contains('standard-overlay--hide')) {
                overlayTarget.classList.remove('standard-overlay--hide')
                body.classList.add('overflow-hidden')
                html.classList.add('overflow-hidden')
            } else {
                overlayTarget.classList.add('standard-overlay--hide')
                body.classList.remove('overflow-hidden')
                html.classList.remove('overflow-hidden')
            }
        }
    }

    overlayToggle () {
        let overlayToggle = document.querySelectorAll('.overlay-toggle')
        let showClass = 'overlay-toggle-element--show'
        let body = document.querySelector('body')
        let html = document.querySelector('html')

        overlayToggle.forEach(function (el) {
            el.addEventListener('click', function () {
                let toggleSelector = el.getAttribute('data-overlay-toggle')
                let toggleElement = document.querySelector(toggleSelector)
                if (toggleElement) {
                    if (toggleElement.classList.contains(showClass)) {
                        toggleElement.classList.remove(showClass)
                        body.classList.remove('overflow-hidden')
                        html.classList.remove('overflow-hidden')
                    } else {
                        toggleElement.classList.add(showClass)
                        body.classList.add('overflow-hidden')
                        html.classList.add('overflow-hidden')
                    }
                }
            })
        })
    }

    updateCartCounter () {
        let cartCount = document.querySelectorAll('.cart-count')

        fetch('/cart.json')
            .then((response) => {
                return response.json()
            })
            .then((data) => {
                let cartNum = data.item_count
                if (cartNum !== null) {
                    for (var i = 0; i < cartCount.length; i++) {
                        cartCount[i].innerHTML = cartNum
                        if (cartNum < 1) {
                            cartCount[i].classList.add('hide')
                        } else {
                            cartCount[i].classList.remove('hide')
                        }
                    }
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }
}

export default Utils



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Utils.js